import React, { useEffect, useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import Button from '../components/common/Button';

export default function Success() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(!!sessionId);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [sessionId, searchParams]);

  const handleContinueToProfile = () => {
    const paymentInfo = {
      sessionId,
      timestamp: Date.now(),
      type: 'job-seeker'
    };
    localStorage.setItem('paymentCompleted', JSON.stringify(paymentInfo));
    navigate('/job-seekers');
  };

  const handleContinueToMarketplace = () => {
    const paymentInfo = {
      sessionId,
      timestamp: Date.now(),
      type: 'resource'
    };
    localStorage.setItem('paymentCompleted', JSON.stringify(paymentInfo));
    navigate('/marketplace');
  };

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Processing Payment | RanchWorkUSA</title>
        </Helmet>
        
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin h-12 w-12 border-4 border-green-500 border-t-transparent rounded-full mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Processing Payment</h2>
            <p className="text-gray-600">Please wait while we confirm your payment...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Payment Successful | RanchWorkUSA</title>
        <meta name="description" content="Your payment was processed successfully" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-6" />
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Payment Successful!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Thank you for your payment. Choose what you'd like to create:
          </p>

          <div className="space-y-4">
            <Button 
              variant="primary" 
              fullWidth 
              icon={ArrowRight}
              onClick={handleContinueToProfile}
            >
              Create Job Seeker Profile
            </Button>
            
            <Button 
              variant="primary" 
              fullWidth 
              icon={ArrowRight}
              onClick={handleContinueToMarketplace}
            >
              Create Resource Listing
            </Button>
            
            <Link to="/job-seekers">
              <Button variant="outline" fullWidth>
                Browse Workers Instead
              </Button>
            </Link>
          </div>

          {sessionId && (
            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-xs text-gray-500">
                Transaction ID: {sessionId.slice(-8)}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}